
import ClickOutside from 'vue-click-outside';

export default {
  directives: {
    clickOutside: ClickOutside,
  },
  data() {
    return {
      isExpanded: false,
    };
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick);
  },

  destroyed() {
    document.removeEventListener('click', this.handleOutsideClick);
  },

  methods: {
    toggle() {
      this.isExpanded = !this.isExpanded;
      this.$emit('toggled', this.isExpanded);
    },
    hide() {
      this.isExpanded = false;
    },
  },
};
